import React, { useEffect, useState } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import WidgetCard from './WidgetCard';
import CardTitle from './CardTitle';
import CenteredSpinner from '../../../components/CenteredSpinner';
import DashboardServices from '../../../services/DashboardServices';
import localStorageService from '../../../services/localStorageService';

const CaseResolutionTime = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState(true);
    const [resolutionData, setResolutionData] = useState({
        average_days: 0,
        median_days: 0,
        total_cases: 0
    });

    useEffect(() => {
        let mounted = true;
        const load = async () => {
            setLoading(true);
            try {
                // Get params with organization_id if applicable
                const storedUser = localStorageService?.getItem?.('user') ?? null;
                const roles = (storedUser?.roles) || (storedUser?.role) || storedUser?.rolesArray || [];
                const normalizedRoles = Array.isArray(roles) ? roles.map(r => String(r).toLowerCase()) : [];
                const targetRoles = ['organization admin', 'case officer', 'case manager', 'organization head', 'director cid', 'director ncpa', 'deputy director','oic','department head','team leader first respondent','call center officer mowca', 'counselling officer', 'legal officer'];
                const hasTargetRole = normalizedRoles.some(r => targetRoles.includes(r));

                const params = {};

                if (hasTargetRole) {
                    const orgId = storedUser?.employee?.organization_id ?? storedUser?.organization_id ?? storedUser?.org?.id ?? null;
                    if (orgId) params.organization_id = orgId;
                }
                const targetEmployee_id_Roles = ['case officer', 'first respondent', 'counselling officer', 'legal officer'];
                const needToPassUserId = normalizedRoles.some(r => targetEmployee_id_Roles.includes(r));
                if (needToPassUserId) {
                    const employeeId = storedUser?.employee?.id ?? storedUser?.employee_id ?? null;
                    if (employeeId) params.assigned_to_officer_id = employeeId;
                }

                const res = await DashboardServices.getDashboardCaseResolutionTime(params);
                const payload = res?.data ?? res;
                // Expected: { view: { msg, data: { average_days, median_days, total_cases } } }
                const data = payload?.view?.data ?? payload?.data ?? {};

                if (mounted) {
                    setResolutionData({
                        average_days: Number(data.average_days) || 0,
                        median_days: Number(data.median_days) || 0,
                        total_cases: Number(data.total_cases) || 0
                    });
                }
            } catch (err) {
                console.error('Failed to load case resolution time', err);
            } finally {
                if (mounted) setLoading(false);
            }
        };

        load();
        return () => { mounted = false; };
    }, []);

    // if (loading) return <WidgetCard sx={{ minHeight: 200,height:'100%' }}><CenteredSpinner /></WidgetCard>;

    return (
        <WidgetCard sx={{ minHeight: 200, height: '100%' }}>
            <Stack spacing={2}>
                <CardTitle>Average time to resolution</CardTitle>
                <Stack direction="row" spacing={0.5} alignItems="baseline">
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 700,
                            color: theme.palette.primary.main,

                        }}
                    >
                        {resolutionData.average_days.toFixed(1)}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: theme.palette.primary.main,
                            fontWeight: 500
                        }}
                    >
                        days
                    </Typography>
                </Stack>
                <Typography className='mt-5' variant="body2" color="text.secondary">
                    Median: {resolutionData.median_days.toFixed(1)}
                </Typography>
            </Stack>
        </WidgetCard>
    );
};

export default CaseResolutionTime;
